/*
 *  GENERAL APP LINKS
 */

export const APP_DRAWER_TOP = [
  {
    to: { name: "Home" },
    title: "commons.drawer.home",
    icon: "mdi-home"
  },
  {
    to: { name: "Projects" },
    title: "Espaces",
    icon: "mdi-folder-open"
  },
  {
    icon: "mdi-calendar-month-outline",
    to: { name: "ReservationsAdminCalendar" },
    title: "Calendrier"
  }
]

export const APP_DRAWER_BOTTOM = [
  {
    to: { name: "Administration" },
    title: "commons.drawer.administration",
    icon: "mdi-account-cog-outline",
    // isAllowed: $ => $.$store.getters["app/isCompanyOwner"]
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "Admin" },
    title: "commons.drawer.admin",
    icon: "mdi-security",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    disabled: true,
    to: { name: "Help" },
    title: "commons.drawer.help",
    icon: "mdi-help"
  }
]

/*
 *  USER ADMINISTRATION LINKS
 */
export const ADMINISTRATION_DRAWER_TOP = [
  {
    to: { name: "AdministrationUsers" },
    title: "commons.drawer.users",
    icon: "mdi-account-group"
  },
  {
    to: { name: "AdministrationUsersPending" },
    title: "commons.drawer.userPending",
    icon: "mdi-email-alert-outline"
  },
  {
    to: "#",
    title: "commons.drawer.facturation",
    icon: "mdi-credit-card-check-outline"
  }
]

/*
 *  ADMIN LINKS
 */

export const ADMIN_DRAWER_TOP = [
  {
    to: { name: "AdminSummary" },
    title: "commons.drawer.summary",
    icon: "mdi-home-analytics"
  },
  {
    to: { name: "CompaniesPlans" },
    title: "commons.drawer.companies_plans",
    icon: "mdi-domain"
  },
  {
    to: { name: "Analytics" },
    title: "commons.drawer.analytics",
    icon: "mdi-chart-line"
  },
  {
    to: { name: "AdminValidation" },
    title: "commons.drawer.validation",
    icon: "mdi-account-plus"
  },
  {
    to: { name: "AdminTemplates" },
    title: "commons.drawer.template",
    icon: "mdi-file-document-multiple"
  },
  {
    to: { name: "AdminActions" },
    title: "commons.drawer.privilege",
    icon: "mdi-gesture-double-tap"
  },
  {
    to: { name: "AdminAPIUsers" },
    title: "commons.drawer.apiUsers",
    icon: "mdi-account-group"
  }
]

/*
 *  PROJECT LINKS WITHOUT PCQ
 */

export const PROJECT_DRAWER_TOP = [
  {
    icon: "mdi-home",
    to: { name: "Project" },
    title: "commons.drawer.general",
    tooltip: "commons.drawer.general"
  },
  {
    icon: "mdi-calendar-month-outline",
    to: { name: "ReservationsCalendar" },
    title: "Calendrier",
    tooltip: "Calendrier des reservations"
  },
  {
    icon: "mdi-calendar-clock-outline",
    to: { name: "Reservations" },
    title: "Reservations",
    tooltip: "Gestion des reservations"
  },
  {
    icon: "mdi-account-group-outline",
    to: { name: "Customers" },
    title: "Clients",
    tooltip: "Gestion des clients"
  },
  {
    icon: "mdi-cash-sync",
    to: { name: "AuthorisationDetail" },
    title: "Dépense",
    tooltip: "Sortie de caisse"
  },
  {
    icon: "mdi-chart-line",
    to: { name: "Financial" },
    title: "Bilan",
    tooltip: "Bilan"
  },
  {
    to: { name: "SpaceDetail" },
    title: "Configurations",
    icon: "mdi-cogs",
    tooltip: "Configurations"
  }
]

export const PROJECT_DRAWER_BOTTOM = [
  {
    icon: "mdi-account-group-outline",
    to: { name: "ProjectTeam" },
    title: "commons.drawer.team"
  }
]

/*
 *  TEMPLATE LINKS
 */
export const TEMPLATE_DRAWER_TOP = [
  {
    icon: "mdi-bookmark-multiple",
    to: { name: "TemplateList" },
    title: "commons.drawer.customize_templates"
  },
  {
    icon: "mdi-playlist-plus",
    to: { name: "FieldTypeEditor" },
    title: "commons.drawer.customize_fieldtypes"
  }
]

/*
 *  PROFILE LINKS
 */

export const PROFILE_DRAWER_TOP = [
  {
    to: { name: "Profile" },
    title: "commons.drawer.personal_settings",
    icon: "mdi-account-cog-outline"
  },
  /*{
    to: { name: "CompanyDepartment" },
    title: "commons.drawer.company_department",
    icon: "mdi-apps"
  },*/
  {
    to: { name: "CompanyMembers" },
    title: "commons.drawer.company_members",
    icon: "mdi-account-group"
  },
  {
    to: { name: "Logout" },
    title: "views.signup_in.signout",
    icon: "mdi-logout"
  }
]
